// Import external
import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

interface Link {
    name: string;
    url: string;
}

@Component({

    selector: 'syn-links-input',
    templateUrl: 'form-links.component.html',
    styleUrls: ['form-links.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => FormLinksComponent),
        }
    ]
})
export class FormLinksComponent implements ControlValueAccessor, OnInit {

    editedLink: Link | null = null;
    editedLinkValues: Link | null = null;
    displayedColumns = ['name', 'url', 'actions'];
    dataSource = new MatTableDataSource<Link>();
    createLinkForm: FormGroup;

    private _links: Link[];

    constructor(private formBuilder: FormBuilder) { }

    @Input('options')
    get options() {
        return this._links;
    }

    set options(val) {
        this._links = val;
        this.onChange(val);
        this.onTouched();
        this.dataSource.data = this._links;
    }

    // these functions will be registered later
    onChange: any = () => { };
    onTouched: any = () => { };
    validateFn: any = () => { };

    public deleteLink(link: Link) {
        this.writeValue(this._links.filter(l => l !== link));
    }

    public addLink() {
        const { name, url } = this.createLinkForm.getRawValue();
        this.writeValue(this._links.concat([{ name, url }]));
        this.createLinkForm.reset();
    }

    public editLink(link: Link) {
        this.editedLink = link;
        this.editedLinkValues = { ...link };
    }

    public cancelLinkEdition() {
        this.editedLink = null;
        this.editedLinkValues = null;
    }

    public confirmLinkEdition() {
        this.editedLink.name = this.editedLinkValues.name;
        this.editedLink.url = this.editedLinkValues.url;
        this.writeValue(this._links);
        this.editedLink = null;
        this.editedLinkValues = null;
    }

    writeValue(value) {
        if (value) {
            this.options = value;
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    validate(c: FormControl) {
        return this.validateFn(c);
    }

    ngOnInit(): void {
        this.createLinkForm = this.formBuilder.group({
            name: ['', Validators.required],
            url: ['', Validators.required]
        });
    }
}
